import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { UploadTestCenterUsersService } from "src/app/shared";
import { AlertService } from "../../../shared/services/alert/alert.service";
import Swal from "sweetalert2";
import { CoreService, SettingsService } from "../../../shared/services";
import { first } from "rxjs/operators";

@Component({
  selector: "app-test-center-user",
  templateUrl: "./test-center-user.component.html",
  styleUrls: ["./test-center-user.component.scss"]
})
export class TestCenterUserComponent implements OnInit {
  testCenterUser: any = {

    center_id: "",
    phone: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    email: "",
    user_type: ""
  };
  sender = "test-center-user";
  testcenteruserId: any;
  error: any;
  usertypes: any = [];
  password:any = "";

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private uploadTestCenterUsersService: UploadTestCenterUsersService,
    private alertService: AlertService,
    private coreService: CoreService,
    private settingsService: SettingsService
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.testcenteruserId = params.get("id");

      if (!this.isNew()) {
        this.getTestCenterUserById();
      }
    });

    this.loadUserTypes();
  }

  loadUserTypes() {
    this.settingsService.getUserTypes()
      .pipe(first())
      .subscribe(res => {
        this.usertypes = res;
      });
  }

  isNew() {
    return this.testcenteruserId == "new";
  }

  getTestCenterUserById() {
    this.uploadTestCenterUsersService
      .getTestCenterUserById(this.testcenteruserId)
      .pipe(first())
      .subscribe(res => {
        this.testCenterUser = res;
      });
  }

  isNotSpecialCharAndNumber(evt) {
    return this.coreService.isNotSpecialCharAndNumber(evt);
  }


  saveTestCenterUser() {
    this.error = " ";


    if (!this.testCenterUser.center_id) {
      this.alertService.err(this.sender, "Center Id can not be blank");
      return false;
    }

    if (!this.testCenterUser.phone) {
      this.alertService.err(this.sender, "Phone no can not be blank");
      return false;
    }
    if (!this.testCenterUser.first_name) {
      this.alertService.err(this.sender, "First name can not be blank");
      return false;
    }
    if (!this.testCenterUser.last_name) {
      this.alertService.err(this.sender, "Last name can not be blank");
      return false;
    }
    if (!this.testCenterUser.email) {
      this.alertService.err(this.sender, "Email Id can not be blank");
      return false;
    }
    if (!this.testCenterUser.user_type) {
      this.alertService.err(this.sender, "user Type can not be blank");
      return false;
    }
    this.uploadTestCenterUsersService
      .saveTestCenterUser(this.testCenterUser)
      .pipe(first())
      .subscribe(res => {
        if (res["status"] == "error") {
          this.alertService.err(this.sender, res["message"]);
          return;
        }
        this.alertService.show(this.sender, "Test Center User Data Saved");
        setTimeout(() => {
          this.router.navigate(["manager/upload-test-center-user-list"]);
        }, 1000);
      });
  }


  public inputValidator(event: any) {
    //console.log(event.target.value);
    const pattern = /^[a-zA-Z]*$/;
    //let inputChar = String.fromCharCode(event.charCode)
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^a-zA-Z]/g, "");
      // invalid character, prevent input

    }
  }

  deleteTestCenterUser() {
    Swal.fire({
      title: "Are you sure?",
      text:
        "Test Center User data will be deleted. This action can't be reversed!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it"
    }).then(result => {
      if (result.value) {
        this.uploadTestCenterUsersService
          .deleteTestCenterUserById(this.testcenteruserId)
          .pipe(first())
          .subscribe(res => {
            this.onCancel();
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.router.navigate(["manager/testcenter/" + this.testcenteruserId]);
      }
    });
  }

  onCancel() {
    this.router.navigate(["/manager/upload-test-center-user-list"]);
  }

  onGetPass (){
     var data = {
      
      testcenteruserId: this.testcenteruserId
    };

    this.uploadTestCenterUsersService
      .getPassword(data)
      .pipe(first())
      .subscribe( (res:any) => {
        if (res["status"] == "error") {
          this.alertService.err(this.sender, res["message"]);
          return;
        }
        this.password = res.pass;


      });
  }

  resetPassword() {
    var data = {
      email: this.testCenterUser.email,
      first_name: this.testCenterUser.first_name,
      last_name: this.testCenterUser.last_name,
      center_id: this.testCenterUser.center_id,
      phone: this.testCenterUser.phone,
      testcenteruserId: this.testcenteruserId
    };

    this.uploadTestCenterUsersService
      .resetPassword(data)
      .pipe(first())
      .subscribe(res => {
        if (res["status"] == "error") {
          this.alertService.err(this.sender, res["message"]);
          return;
        }
        this.alertService.show(this.sender, "Password Reset Successfully");


      });
  }

}
